// src/main.tsx
// CRITICAL: Install WASM guard FIRST to detect rogue imports
import './features/dms/diagnostics/wasmGuard.main';

// React import kept as a stub for future use
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppInitializer from './AppInitializer.tsx'; // Import the new AppInitializer
import './index.css'; // Your Tailwind global styles

ReactDOM.createRoot(document.getElementById('root')!).render(
  //<React.StrictMode> {/* Keep StrictMode for now, we'll see if it causes issues */}
    <AppInitializer />
  //</React.StrictMode>
);